import { type JSX, useMemo } from "react";

import { isTruthy } from "@vega-core/utils/isTruthy";

type Props = {
  activeStep: number;
  navGroupSplitters?: number[];
  steps: JSX.Element[] | string[];
};

export const HorizontalStepIndicator = ({
  activeStep,
  navGroupSplitters,
  steps,
}: Props) => {
  const navPoints = useMemo(
    () =>
      isTruthy(navGroupSplitters?.length)
        ? [-1, ...navGroupSplitters]
        : steps.map((_, index) => index),
    [navGroupSplitters, steps],
  );

  return (
    <div className="flex w-full justify-stretch">
      {navPoints.map((stepNumber, index) => {
        const isActive = navGroupSplitters
          ? activeStep > stepNumber
          : activeStep >= index;

        return (
          <div className="my-2 flex flex-1 items-center" key={stepNumber}>
            <div className="mr-2 h-1.5 flex-1 rounded-companyBorderRadius bg-background/tertiary">
              <div
                className={`rounded-companyBorderRadius bg-brand-default ${isActive ? "h-1.5" : ""}`}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
